<template>
  <div class="onetest" v-if="twoItem">
    <h2>{{twoItem.name }}</h2>
    <div v-for="(obj,index) in twoItem.list" :key="index" class="topicBox">
      <div class="topicBox_big" v-if="!obj.special && !obj.lastVoice">
        <div class="topicBox_1">
          <div v-if="obj.picture" class="picturePlace">({{obj.picture}})</div>
          <div>{{obj.name}}</div>
          <audioMp3 v-if="obj.audioS" :audioUrl="obj.audioS" class="audioMp3"></audioMp3>
        </div>

        <div class="checkboxS">
          <div class="checkboxS_box">
            <div v-if="obj.question" class="checkboxS_box_1" style="text-align: center">
              计 分
              <div class="checkboxS_box_1_2">受测反应</div>
            </div>
            <el-radio-group v-model="obj.grade">
              <el-radio :label="1">1</el-radio>
              <el-radio :label="2">0</el-radio>
              <el-radio :label="3">无反应</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class v-if="obj.special">
        <div class="topicBox_1">
          <div v-if="obj.picture" class="picturePlace">({{obj.picture}})</div>
          <div>{{obj.name}}</div>
          <audioMp3 v-if="obj.audioS" :audioUrl="obj.audioS" class="audioMp3"></audioMp3>
        </div>
        <div v-for="(objZoo,index) in obj.zooList" :key="index" class="objZooScss">
          <div class="fontSize">{{objZoo.name}}</div>
          <el-radio-group v-model="objZoo.grade">
            <el-radio :label="1">1</el-radio>
            <el-radio :label="2">0</el-radio>
            <el-radio :label="3">无反应</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div class="lastVoice">
      {{twoItem.nameAll}}
      <el-form ref="form" class="form" label-width="10px">
        <el-form-item>
          <el-input v-model="twoItem.grade" :disabled="true"></el-input>
        </el-form-item>
      </el-form>分
    </div>
  </div>
</template>

<script>
import audioMp3 from "./audioMp3.vue";
export default {
  name: "onetest",
  components: {
    audioMp3
  },
  props: {
    twoItem: {}
  },
  data() {
    return {
      grade: ""
    };
  },
  created() {},
  mounted() {},
  watch: {
    "twoItem.list": {
      handler(newVal) {
        this.filterVal(newVal);
      },
      // immediate: true,
      deep: true
    }
    // twoItem: {
    //   handler(newVal) {
    //     // console.log(newVal);
    //     this.filterVal(newVal);
    //   },
    //   immediate: true,
    //   deep: true
    // }
  },
  computed: {},
  methods: {
    filterVal(newVal) {
      let arr = newVal.map(item => {
        return (
          item.grade || (item.zooList && item.zooList.map(obj => obj.grade))
        );
      });
      if (arr) {
        let result = [];
        result = arr.flat().filter(res => res == 1);
        if (result) {
          this.twoItem.grade = JSON.parse(JSON.stringify(result.length));
        }
      }
    }
    // allNum(value) {
    //   this.grade = value;
    //   this.$emit("pointsAll", value);
    // }
  }
};
</script>
<style lang="scss" scoped>
.topicBox {
  font-size: 20px;
  margin: 50px;

  .topicBox_big {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .topicBox_1 {
    display: flex;
  }
}
.audioMp3 {
  margin-left: 30px;
}
.checkboxS {
  display: flex;
  margin-left: 200px;
  .checkboxS_box {
    margin-left: 50px;
    .checkboxS_box_1 {
      display: flex;
      justify-content: center;
      .checkboxS_box_1_2 {
        margin-left: 30px;
      }
    }
  }
}
.objZooScss {
  //   margin: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .fontSize {
    margin-left: 30px;
    margin-top: 30px;
  }
}
.lastVoice {
  font-weight: 800;
  font-size: 20px;
  display: flex;
  justify-content: center;
  line-height: 2;
  margin-bottom: 30px;
  .form {
    border-bottom: 1px solid black;
  }
}
::v-deep .lastVoice {
  .el-form-item {
    margin-bottom: 0;
  }
  .el-input .el-input__inner,
  .el-input.is-disabled .el-input__inner {
    background-color: transparent;
    border: none;
    font-size: 20px;
  }
}
.fontSizeWe {
  font-weight: 800;
}
</style>